import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import TopBar from '../components/layout/TopBar.svelte';
import SegmentedControl from '../components/shared/SegmentedControl.svelte';
import StatCard from '../components/analytics/StatCard.svelte';
import DailyChart from '../components/analytics/DailyChart.svelte';
import TrendLine from '../components/analytics/TrendLine.svelte';
import GoalTracker from '../components/analytics/GoalTracker.svelte';

import {
	getDailySummary,
	getWeeklyOutput,
	getAverageSessionDuration,
	getFeedingFrequency
} from '../lib/services/analytics';

import { formatDuration } from '../lib/utils/time';
import { getSettings } from '../lib/stores/settings.svelte.ts';
import { getActiveChild } from '../lib/stores/children.svelte.ts';
import { formatVolume } from '../lib/utils/units.ts';

var root = $.from_html(`<!> <div class="analytics-page svelte-bsexcnm0gbwy"><div class="stats-row svelte-bsexcnm0gbwy"><!> <!> <!></div> <!> <section class="svelte-bsexcnm0gbwy"><h3 class="svelte-bsexcnm0gbwy">Daily Pump Output</h3> <!></section> <section class="svelte-bsexcnm0gbwy"><!></section> <div class="insight-row svelte-bsexcnm0gbwy"><div class="insight svelte-bsexcnm0gbwy"><span class="insight-label svelte-bsexcnm0gbwy">Avg nursing</span> <span class="insight-value svelte-bsexcnm0gbwy"> </span></div> <div class="insight svelte-bsexcnm0gbwy"><span class="insight-label svelte-bsexcnm0gbwy">Feeds/day</span> <span class="insight-value svelte-bsexcnm0gbwy"> </span></div></div> <!></div>`, 1);

function Analytics($$anchor, $$props) {
	$.push($$props, true);

	const rangeOptions = [
		{ value: '7', label: '7 days' },
		{ value: '14', label: '14 days' },
		{ value: '30', label: '30 days' }
	];

	let range = $.state('7');
	const settings = $.derived(getSettings);
	const activeChild = $.derived(getActiveChild);
	const isImperial = $.derived(() => $.get(settings).units === 'imperial');

	let summary = $.state($.proxy({
		totalPumpMl: 0,
		nursingCount: 0,
		bottleCount: 0,
		bottleVolumeMl: 0,
		totalSessions: 0
	}));

	let weeklyData = $.state($.proxy([]));
	let avgDuration = $.state(0);
	let feedFreq = $.state(0);

	$.user_effect(() => {
		if (!$.get(activeChild)) return;

		loadData();
	});

	async function loadData() {
		if (!$.get(activeChild)) return;

		const days = parseInt($.get(range));
		const id = $.get(activeChild).id;

		$.set(summary, await getDailySummary(id, Date.now()), true);
		$.set(weeklyData, await getWeeklyOutput(id, days), true);
		$.set(avgDuration, await getAverageSessionDuration(id, days, 'nursing'), true);
		$.set(feedFreq, await getFeedingFrequency(id, days), true);
	}

	var fragment = root();
	var node = $.first_child(fragment);

	TopBar(node, { title: 'Analytics', showBack: true, backPath: '/more' });

	var div = $.sibling(node, 2);
	var div_1 = $.child(div);
	var node_1 = $.child(div_1);

	{
		let $0 = $.derived(() => formatVolume($.get(summary).totalPumpMl, $.get(isImperial)));

		StatCard(node_1, {
			label: 'Pumped today',
			get value() {
				return $.get($0);
			}
		});
	}

	var node_2 = $.sibling(node_1, 2);

	StatCard(node_2, {
		label: 'Nursed today',
		get value() {
			return $.get(summary).nursingCount;
		}
	});

	var node_3 = $.sibling(node_2, 2);

	StatCard(node_3, {
		label: 'Bottles',
		get value() {
			return $.get(summary).bottleCount;
		}
	});

	$.reset(div_1);

	var node_4 = $.sibling(div_1, 2);

	SegmentedControl(node_4, {
		get options() {
			return rangeOptions;
		},

		get selected() {
			return $.get(range);
		},
		onchange: (v) => $.set(range, v, true)
	});

	var section = $.sibling(node_4, 2);
	var node_5 = $.sibling($.child(section), 2);

	DailyChart(node_5, {
		get data() {
			return $.get(weeklyData);
		}
	});

	$.reset(section);

	var section_1 = $.sibling(section, 2);
	var node_6 = $.child(section_1);

	TrendLine(node_6, {
		get data() {
			return $.get(weeklyData);
		},
		valueKey: 'sessionCount',
		label: 'Feeding Frequency'
	});

	$.reset(section_1);

	var div_2 = $.sibling(section_1, 2);
	var div_3 = $.child(div_2);
	var span = $.sibling($.child(div_3), 2);
	var text = $.child(span, true);

	$.reset(span);
	$.reset(div_3);

	var div_4 = $.sibling(div_3, 2);
	var span_1 = $.sibling($.child(div_4), 2);
	var text_1 = $.child(span_1, true);

	$.reset(span_1);
	$.reset(div_4);
	$.reset(div_2);

	var node_7 = $.sibling(div_2, 2);

	GoalTracker(node_7, {});
	$.reset(div);

	$.template_effect(
		($0, $1) => {
			$.set_text(text, $0);
			$.set_text(text_1, $1);
		},
		[
			() => $.get(avgDuration) > 0 ? formatDuration($.get(avgDuration)) : '—',
			() => $.get(feedFreq) > 0 ? $.get(feedFreq).toFixed(1) : '—'
		]
	);

	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	Analytics = $.hmr(Analytics);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-bsexcnm0gbwy');
		Analytics[$.HMR].update(module.default);
	});
}

export default Analytics;
import "bun-svelte:Analytics.svelte-2ocihoblwxcap-style.css";